var _defs, _rect, _rect2, _rect3, _rect4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTechnonet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 12.705,
    viewBox: "0 0 85 12.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 12.705,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.964,
    height: 1.628,
    transform: "translate(22.933 0.021)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.669,
    height: 8.756,
    transform: "translate(25.102 2.223)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.964,
    height: 1.628,
    transform: "translate(79.036 0.021)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.669,
    height: 8.756,
    transform: "translate(81.197 2.223)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.025.025h-4.232a1.953,1.953,0,0,0-1.766,1.849V9.132a1.942,1.942,0,0,0,2.015,1.849c.193,0,3.983,0,3.983,0V9.326h-3.983a.368.368,0,0,1-.346-.345c0-.115-.013-6.693,0-6.886a.4.4,0,0,1,.353-.407c.159-.007,3.976,0,3.976,0Z",
    transform: "translate(-72.541 -0.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.753.025h-4.231a1.953,1.953,0,0,0-1.767,1.849V9.132a1.942,1.942,0,0,0,2.015,1.849c.193,0,3.983,0,3.983,0V9.326H126.77a.367.367,0,0,1-.346-.345c0-.115-.014-6.693,0-6.886a.4.4,0,0,1,.352-.407c.159-.007,3.977,0,3.977,0Z",
    transform: "translate(-88.701 -0.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.735,
    height: 1.656,
    transform: "translate(31.748 4.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.615.025h-4.232a1.953,1.953,0,0,0-1.766,1.849V9.132a1.942,1.942,0,0,0,2.015,1.849c.193,0,3.983,0,3.983,0V9.326h-3.983a.367.367,0,0,1-.345-.345c0-.115-.014-6.693,0-6.886a.4.4,0,0,1,.352-.407c.159-.007,3.977,0,3.977,0Z",
    transform: "translate(-178.189 -0.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.735,
    height: 1.656,
    transform: "translate(74.69 4.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.681,
    height: 10.971,
    transform: "translate(42.606 0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88.009V4.432h-2.789v1.6h2.815v4.947H159.6V.009Z",
    transform: "translate(-110.27 -0.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.933,4.99V14.5h1.638V8.688Z",
    transform: "translate(-123.667 -3.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.87,0l4.784,10.955h1.821V0h-1.711V7.077L175.692,0Z",
    transform: "translate(-123.622 -0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.12,4.99V14.5h1.637V8.688Z",
    transform: "translate(-160.061 -3.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.056,0l4.783,10.955h1.821V0h-1.71V7.077L226.877,0Z",
    transform: "translate(-160.015 -0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.005,1.637A1.856,1.856,0,0,0,204,0h-2.7a2.049,2.049,0,0,0-1.9,1.9V9.144a2.121,2.121,0,0,0,1.821,1.822c.349,0,2.3.018,2.779,0a1.87,1.87,0,0,0,2.005-1.8c.018-.442,0-7.176,0-7.525M204.4,8.9a.4.4,0,0,1-.4.46h-2.5a.482.482,0,0,1-.442-.46V2.042a.377.377,0,0,1,.4-.35h2.429a.467.467,0,0,1,.515.368Z",
    transform: "translate(-141.774 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.518,2.883c-3.591,1.138-7.336,5.018-5.752,7.29,1.3,1.868,6.684,1,9.9-2.938a11.835,11.835,0,0,1-5.147,5.528c-4.1,2.453-8.481,2.669-9.788.484s.955-5.944,5.053-8.4a13.48,13.48,0,0,1,5.729-1.968",
    transform: "translate(-13.058 -2.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20.247c-5.342.6-12.71,1.28-18.294,7.28C5.229,3.626,4.729.085,0,0",
    transform: "translate(0 -0.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.306,2.307c.585.977-.427,2.657-2.259,3.754s-3.791,1.193-4.375.216S49.1,3.62,50.931,2.524s3.791-1.193,4.376-.217",
    transform: "translate(-34.488 -1.161)",
    fill: "#e50615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.853,3.108c.311.52-.228,1.415-1.2,2s-2.02.636-2.331.115.228-1.416,1.2-2,2.02-.636,2.332-.115",
    transform: "translate(-41.402 -1.954)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTechnonet);
export default __webpack_public_path__ + "static/media/logo_technonet.e925983296e268db0245708747d66456.svg";
export { ForwardRef as ReactComponent };